import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../../../api/v1/models/currency';

@Pipe({
  name: 'priceCurrency',
})
export class PriceCurrencyPipe implements PipeTransform {

  private price: string;

  transform(
    value: number,
    currency: Currency | null,
    locale: string | undefined | null): string {

    if (value && locale && currency) {
      value = Math.round(value * 100) / 100;
      if (locale === 'en_GB') {
        this.price = currency.symbol + ' ' + value.toString();
      } else {
        this.price = value.toString() + ' ' + currency.symbol;
      }
    } else {
      this.price = value?.toString();
    }

    return this.price;
  }
}
